import { GlobalNotice, useGlobalNotices } from '@/hooks/global-notices'
import { InfoIcon, TriangleAlertIcon } from 'lucide-react'
import { Alert, AlertDescription } from '../ui/alert'

export function GlobalNotices() {
  const { notices } = useGlobalNotices()

  // No notices, nothing to render
  if (notices.length === 0) return null

  // Render all notices
  return (
    <div className="flex flex-col gap-2">
      {notices.map(({ key, ...notice }) => (
        <GlobalNoticeItem key={key} {...notice} />
      ))}
    </div>
  )
}

function GlobalNoticeItem({ type, message }: GlobalNotice) {
  if (type === 'info')
    return (
      <Alert className="border-info bg-info-background flex items-center gap-4 border-l-6 p-3">
        <InfoIcon className="stroke-info" />
        <AlertDescription className="text-info-foreground flex flex-1 flex-col gap-2">
          {message}
        </AlertDescription>
      </Alert>
    )

  if (type === 'warning')
    return (
      <Alert className="border-warning bg-warning-background flex items-center gap-4 border-l-6 p-3">
        <TriangleAlertIcon className="stroke-warning" />
        <AlertDescription className="text-warning-foreground flex flex-1 flex-col gap-2">
          {message}
        </AlertDescription>
      </Alert>
    )

  if (type === 'error')
    return (
      <Alert className="border-destructive bg-destructive-background flex items-center gap-4 border-l-6 p-3">
        <TriangleAlertIcon className="stroke-destructive" />
        <AlertDescription className="text-destructive-foreground flex flex-1 flex-col gap-2">
          {message}
        </AlertDescription>
      </Alert>
    )

  throw new Error(`Unsupported global notice type: ${type}`)
}
